import r from "./index.es6.js";
function m(e, t, o) {
  return r[e.type](e, t, o);
}
export {
  m as default
};
//# sourceMappingURL=index.es20.js.map
